export enum PaynimoAction {
    POST_MANDATE_DATA = "post_mandate_data",
    REQUEST_MANDATE_DATA = "request_mandate_data"
}